import { useFormContext } from "react-hook-form";
import { SwitchInput } from "../SwitchInput";

const switchInputs = [
  {
    id: "oversized-shipments",
    stepName: "step3.oversizedShipments",
    label:
      "Any oversized shipments?",
  },
  {
    id: "brokerage-authority",
    stepName: "step3.brokerageAuthority",
    label:
      "Do you have brokerage authority?",
  },
  {
    id: "owner-operators",
    stepName: "step3.ownerOperators",
    label:
      "Do you use owner operators?",
  },
  {
    id: "interline-agreement",
    stepName: "step3.interlineAgreement",
    label:
      "Do you have an interline agreement?",
  },
  {
    id: "interchange-agreement",
    stepName: "step3.interchangeAgreement",
    label:
      "Do you have an interchange agreement?",
  },
  {
    id: "intermodal-agreement",
    stepName: "step3.intermodalAgreement",
    label:
      "Do you have an intermodal agreement?",
  },
  {
    id: "lease-vehicles-trailers",
    stepName: "step3.leaseVehiclesTrailers",
    label:
      "Do you lease vehicles or trailers to others?",
  },
  {
    id: "travel-mexico",
    stepName: "step3.travelMexico",
    label:
      "Do you travel into Mexico?",
  },
  {
    id: "travel-canada",
    stepName: "step3.travelCanada",
    label:
      "Do you travel into Canada?",
  },
  {
    id: "team-drivers",
    stepName: "step3.teamDrivers",
    label:
      "Do you use team drivers?",
  },
  {
    id: "guest-passengers",
    stepName: "step3.guestPassengers",
    label:
      "Do you allow guest passengers?",
  },
  {
    id: "subsidiary",
    stepName: "step3.subsidiary",
    label: "Are you a subsidiary?",
  },
  {
    id: "trip-leasing-under-authority",
    stepName: "step3.tripLeasingUnderAuthority",
    label: "Do you allow trip leasing under your authority?",
  },
];
export function MotorCarrierType() {
  const methods = useFormContext();
  const { control } = methods;
  return (
    <div className="rounded-lg p-0 space-y-4">
      <h3 className="text-xl font-semibold">Motor Carrier Type</h3>
      {switchInputs.map(({ id, stepName, label }) => (
        <SwitchInput
          key={id}
          control={control}
          id={id}
          stepName={stepName}
          stepId="step3"
          label={label}
        />
      ))}
    </div>
  );
}
